// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
    minHeight: 0,
    backgroundColor: theme.white,
  },

  messagesList: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.other.spacing._16,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12,
    minHeight: 0,

    '&::-webkit-scrollbar': {
      width: '6px',
    },

    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },

    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.gray[4],
      borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '3px',
    },

    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.colors.gray[5],
    },
  },

  messageItem: {
    width: '100%',
    flexShrink: 0,
    '&:not(:last-child)': {
      marginBottom: theme.other.spacing._4,
    },
  },

  loader: {
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.gray2[3], // #909296
    fontSize: '12px',
    padding: theme.other.spacing._8,
    marginBottom: theme.other.spacing._12,
  },
}));
